import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Image,
  Avatar,
  Comment,
  Tag,
} from "antd";
import Animate from "rc-animate";
import ReactTimeAgo from "react-time-ago";
import {
  LikeOutlined,
  CommentOutlined,
  LikeTwoTone,
  MessageTwoTone,
} from "@ant-design/icons";
import * as FirestoreService from "../../firebase";
import AddComments from "./AddComments";
const { Text, Title, Paragraph } = Typography;

const Post = ({ post }) => {
  const user = useSelector((state) => state.user);
  const profile = useSelector((state) => state.profile);

  const [viewComments, setViewComments] = useState(false);

  function canViewPost() {
    if (post.isPublic) {
      return true;
    } else if (profile.odinMember) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <Animate transitionName="fade" transitionAppear>
      <Card
        loading={!canViewPost()}
        key={post.id}
        style={{
          borderRadius: 10,
          marginBottom: 25,
          boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
        }}
        size="small"
        title={
          <Row align="middle" gutter={[10, 4]} justify="space-between">
            <Row style={{ marginLeft: 10 }}>
              <Col>
                {post.userAvatarUrl ? (
                  <Avatar size="large" src={post.userAvatarUrl} />
                ) : (
                  <Avatar size="large">{post.userAvatarSymbols}</Avatar>
                )}
              </Col>
              <Col style={{ marginLeft: 5 }}>
                <Row>
                  <Col>
                    <Title level={5}>{post.username}</Title>
                  </Col>
                </Row>
                <Row>
                  {post.publishAt && (
                    <Text type="secondary" style={{ fontSize: 10 }}>
                      <ReactTimeAgo
                        date={post.publishAt.toDate()}
                        timeStyle="round-minute"
                      />
                    </Text>
                  )}
                </Row>
              </Col>
            </Row>
            <Col>
              {!canViewPost() && (
                <Tag color="green" style={{ borderRadius: 5 }}>
                  Members Only
                </Tag>
              )}
            </Col>
          </Row>
        }
      >
        <Row>
          <Paragraph style={{ fontSize: 14, marginBottom: 5 }}>
            {post.content}
          </Paragraph>
        </Row>

        {post.imgUrl && (
          <Image
            preview={false}
            src={post.imgUrl}
            style={{ maxHeight: "500px" }}
          />
        )}

        <Row justify="space-between" gutter={10}>
          <Col>
            {post.likedBy ? (
              <>
                <LikeTwoTone />
                {post.likedBy.includes(user.username) ? (
                  post.likedBy.length === 1 ? (
                    <Text> by You</Text>
                  ) : (
                    <Text> You and {post.likedBy.length} other</Text>
                  )
                ) : post.likedBy.length === 0 ? (
                  <>
                    {" "}
                    <Text> be first to like it!</Text>{" "}
                  </>
                ) : (
                  <Text> {post.likedBy.length} people</Text>
                )}
              </>
            ) : (
              <>
                {" "}
                <LikeTwoTone /> <Text> be first to like it!</Text>{" "}
              </>
            )}
          </Col>
          <Col>
            {post.comments ? (
              post.comments.length > 0 ? (
                <>
                  <MessageTwoTone />
                  <Text> {post.comments.length} </Text>
                </>
              ) : (
                <>
                  <MessageTwoTone />
                  <Text> be first to comment! </Text>
                </>
              )
            ) : (
              <>
                <MessageTwoTone />
                <Text> be first to comment! </Text>
              </>
            )}
          </Col>
        </Row>
        <Row justify="space-between" gutter={10}>
          <Col span={12}>
            {post.likedBy ? (
              post.likedBy.includes(user.username) ? (
                <Button
                  block
                  style={{ border: 0, background: "none" }}
                  icon={<LikeOutlined />}
                  className="like-clicked"
                  onClick={() =>
                    FirestoreService.unlinePost(post.id, user.username)
                  }
                >
                  Like
                </Button>
              ) : (
                <Button
                  block
                  style={{ border: 0, background: "none" }}
                  icon={<LikeOutlined />}
                  onClick={() =>
                    FirestoreService.likePost(post.id, user.username)
                  }
                >
                  Like
                </Button>
              )
            ) : (
              <Button
                block
                style={{ border: 0, background: "none" }}
                icon={<LikeOutlined />}
                onClick={() =>
                  FirestoreService.likePost(post.id, user.username)
                }
              >
                Like
              </Button>
            )}
          </Col>
          <Col span={12}>
            <Button
              block
              style={{ border: 0, background: "none" }}
              icon={<CommentOutlined />}
              onClick={() => setViewComments(!viewComments)}
            >
              View Comments
            </Button>
          </Col>
        </Row>
        <Row>
          <AddComments
            postId={post.id}
            afterUpdate={() => setViewComments(true)}
          />
        </Row>
        <Row>
          {post.comments &&
            viewComments &&
            post.comments.map((comment, i) => (
              <Comment
                key={i}
                style={{ width: "100%" }}
                author={
                  <Text type="secondary">
                    <b>{comment.userName}</b>
                  </Text>
                }
                avatar={
                  comment.userAvatarUrl ? (
                    <Avatar src={comment.userAvatarUrl} />
                  ) : (
                    <Avatar>{comment.userAvatarSymbols}</Avatar>
                  )
                }
                content={<Text>{comment.content}</Text>}
                datetime={
                  <ReactTimeAgo
                    date={comment.createdAt.toDate()}
                    timeStyle="round-minute"
                  />
                }
              />
            ))}
        </Row>
      </Card>
    </Animate>
  );
};

export default Post;
